export const puzzles = [
    { name: 'Pet_door', answers: [], remove: [] },
    { name: 'Valencia', answers: [], remove: ['val', 'ncia', 'c', 'f', '1', '2'] },
    { name: 'Adolf_Hitler', answers: [], remove: [] },
    { name: 'Harry_Styles', answers: [], remove: [] },
    { name: 'Donald_Trump', answers: [], remove: [] },
    { name: 'Colorado', answers: [], remove: [] },
    { name: 'Tornado', answers: ['tornadoes'], remove: ['tornado', 'tornadoes'] },
    { name: 'Nebraska', answers: [], remove: [] },
    { name: 'Yahtzee', answers: ['yatzee'], remove: [] },
    { name: 'Joan_of_Arc', answers: [], remove: ['joan', "joan's"] },
    { name: 'Turtle', answers: ['turtles'], remove: ['turtles', 'turtle'] },
    { name: 'Ludwig_van_Beethoven', answers: ['beethoven'], remove: [] },
    { name: 'Polio', answers: [], remove: ['polio', 'poliovirus'] },
    { name: 'Africa', answers: [], remove: ['n', '000', '1'] },
    { name: 'Whale_shark', answers: [], remove: ['whale', 's', 'm'] },
    { name: 'SeaWorld', answers: ['sea world'], remove: ['sea', 'world'] },
    { name: 'Chicken', answers: [], remove: ['s', 'chickens', 'chicken'] },
    { name: 'Jupiter', answers: [], remove: ['000'] },
    { name: 'Toast_(food)', answers: ['toast'], remove: [] },
    { name: 'Monopoly_(game)', answers: ['monopoly'], remove: [] },
    { name: 'SpongeBob_SquarePants', answers: ['spongebob', 'sponge bob'], remove: [] },
    { name: 'First_Amendment_to_the_United_States_Constitution', answers: ['first amendment', '1st amendment'], remove: [] },
    { name: 'Mary_Had_a_Little_Lamb', answers: ['mary had a little lamb'], remove: [] },
    { name: 'Beyoncé', answers: ['beyonce'], remove: [] },
    { name: 'Walt_Disney', answers: ['walt disney'], remove: [] },
    { name: 'Spanish_Inquisition', answers: ['spanish inquisition'], remove: [] },
    { name: 'Phil_McGraw', answers: ['dr phil', 'doctor phil'], remove: [] },
    { name: 'A_Tale_of_Two_Cities', answers: ['a tale of two cities', 'tale of two cities'], remove: [] },
    { name: 'Uptown_Funk', answers: ['uptown funk'], remove: [] },
    { name: 'IPhone', answers: [], remove: [] },
    { name: 'Bible', answers: ['the bible'], remove: [] },
    { name: 'Stephen_Hawking', answers: ['steven hawking', 'stephen hawkin', 'stephen hawkings'], remove: [] },
    { name: 'Chernobyl_disaster', answers: ['chernobyl', 'chernoble', 'chernobel'], remove: [] },
    { name: 'Mark_Zuckerberg', answers: [], remove: [] },
    { name: 'Paris', answers: [], remove: [] },
    { name: 'John Cena', answers: ['john sena'], remove: [] },
    { name: 'Albert_Einstein', answers: ['einstein', 'einstien'], remove: [] },
    { name: 'Darth_Vader', answers: ['lord vader'], remove: [] },
    { name: 'Australia', answers: [], remove: [] },
    { name: 'Top_Gun', answers: [], remove: ['top'] },
    { name: 'Penguin', answers: [], remove: [] },
    { name: 'Bill_Gates', answers: [], remove: [] },
    { name: 'Stranger_Things', answers: [], remove: [] },
    { name: 'Wikipedia', answers: [], remove: [] },
    { name: 'Elvis_Presley', answers: ['elvis'], remove: [] },
    { name: 'Gmail', answers: [], remove: [] },
    { name: 'Cat', answers: [], remove: [] },
    { name: 'Netflix', answers: [], remove: [] },
    { name: 'Mona_Lisa', answers: [], remove: [] },
    { name: 'Theodore_Roosevelt', answers: ['teddy roosevelt'], remove: [] },
    { name: 'Corvus', answers: ['crow'], remove: [] },
    { name: 'Zendaya', answers: [], remove: [] },
    { name: 'Nancy_Pelosi', answers: [], remove: [] },
    { name: 'Minecraft', answers: [], remove: [] },
    { name: 'Scientology', answers: [], remove: [] },
    { name: 'Twitter', answers: [], remove: [] },
    { name: 'New_Zealand', answers: [], remove: [] },
    { name: 'Wordle', answers: [], remove: [] },
    { name: 'Nicolas Cage', answers: ['nick cage', 'nicholas cage'], remove: [] },
    { name: 'Avatar_(2009_film)', answers: ['avatar'], remove: [] },
    { name: 'Twitch_(service)', answers: ['twitch'], remove: [] },
    { name: 'Titanic', answers: ['the titanic'], remove: [] },
    { name: 'Greek_alphabet', answers: ['greek letters'], remove: [] },
    { name: 'NATO_phonetic_alphabet', answers: ['phonetic alphabet', 'nato alphabet'], remove: [] },
    { name: 'Dodgeball:_A_True_Underdog_Story', answers: ['dodgeball'], remove: [] },
    { name: 'Zeus', answers: ['zeus'], remove: [] },
    { name: 'American_Civil_War', answers: ['civil war', 'the civil war'], remove: [] },
    { name: 'Lego', answers: ['legos'], remove: ['legoland'] },
    { name: 'Beer', answers: [], remove: [] },
    { name: 'Maple', answers: ['maple tree'], remove: [] },
    { name: 'Yellowstone_National_Park', answers: ['yellowstone'], remove: [] },
    { name: 'Pelican', answers: [], remove: [] },
    { name: 'Pluto', answers: [], remove: [] },
    { name: 'Kiss_(band)', answers: ['kiss'], remove: [] },
    { name: 'The_Godfather', answers: ['godfather'], remove: [] },
    { name: 'Utah', answers: [], remove: [] },
    { name: 'Prohibition_in_the_United_States', answers: ['prohibition'], remove: [] },
    { name: 'Russia', answers: [], remove: ['russian'] },
    { name: 'Oscar Isaac', answers: [], remove: [] },
    { name: 'Russia', answers: [], remove: [] },
    { name: 'Pizza', answers: [], remove: [] },
    { name: 'Moscow', answers: [], remove: [] },
    { name: 'Cinema_of_the_United_States', answers: ['hollywood'], remove: [] },
    { name: 'Cheese', answers: [], remove: [] },
    { name: 'Russia', answers: [], remove: [] },
    { name: 'Capital_city', answers: ['capital'], remove: [] },
    { name: 'Canada', answers: ['canadian'], remove: ['canadian'] },
    { name: 'Water_buffalo', answers: ['water buffalo'], remove: [] },
    { name: 'Lodon', answers: [], remove: [] },
    { name: 'Thomas_Edison', answers: ['thomas edison', 'edison'], remove: [] },
    { name: 'Egypt', answers: ['egyptian'], remove: ['egyptian'] },
    { name: 'Cairo', answers: [], remove: [] },
    { name: 'Bank', answers: [], remove: ['banking'] },
    { name: 'Electric_power', answers: ['electricity'], remove: [] },
    { name: 'Black_Death', answers: ['plague', 'the plague', 'pestilence', 'bubonic plague'], remove: [] },
    { name: 'Economy', answers: ['economics'], remove: [] },
    { name: 'Watt', answers: [], remove: [] },
    { name: 'Rat', answers: ['rats'], remove: [] },
    { name: 'Homer', answers: [], remove: [] },
    { name: 'Steam', answers: [], remove: [] },
    { name: 'Asia', answers: ['asian'], remove: [] },
    { name: 'Divine_Comedy', answers: ['the divine comedy', 'devine comedy'], remove: [] },
    { name: 'Industrial_Revolution', answers: [], remove: [] },
    { name: 'Pacific_Ocean', answers: ['pacific', 'the pacific'], remove: [] },
    { name: 'Purgatory', answers: [], remove: [] },
];
export function get_puzzle(day) {
    console.log(day);
    return puzzles[day] || puzzles[puzzles.length - 1];
}
